/* assets/giddy-drawer-coord.js
   =========================================================================
   Coordinates the cart drawer and the wishlist drawer so they can be open
   simultaneously without double-darkening the page and so clicking an icon
   for an already-open drawer just brings it to the front instead of
   re-animating the slide-in.

   Both drawers' own JS still owns its slide animation + overlay markup —
   this coordinator just decides:
     1. Should the slide animation play, or is this a front-swap?
     2. Should the OTHER drawer's overlay be hidden right now?
     3. When THIS drawer closes, should the other be brought to front?

   Public API (window.GiddyDrawers):
     .beforeOpen(name)  → { animate: bool, hideOtherOverlay: bool }
     .afterClose(name)  → { showOtherOverlay: bool }
     .isOpen(name)      → bool
   ========================================================================= */
(function () {
  'use strict';
  if (window.GiddyDrawers) return; // singleton

  var state = { cart: false, wishlist: false };

  var DRAWER_IDS = {
    cart:     'cart-drawer',
    wishlist: 'giddy-wishlist-drawer'
  };

  function other(name) { return name === 'cart' ? 'wishlist' : 'cart'; }

  function bringToFront(name) {
    Object.keys(DRAWER_IDS).forEach(function (k) {
      var el = document.getElementById(DRAWER_IDS[k]);
      if (!el) return;
      el.style.zIndex = (k === name) ? '10001' : '9999';
    });
  }

  window.GiddyDrawers = {
    isOpen: function (name) { return !!state[name]; },

    // Caller (drawer JS) invokes this BEFORE its slide animation.
    // - animate=false means the drawer is already open; the caller should
    //   skip the slide and just let the z-index bump bring it to front.
    // - hideOtherOverlay=true means the other drawer's overlay was showing
    //   and the caller (or whichever drawer code is involved) should hide
    //   it so we don't double-darken.
    beforeOpen: function (name) {
      var wasOpen   = state[name];
      var otherOpen = state[other(name)];
      state[name] = true;
      bringToFront(name);
      return {
        animate: !wasOpen,
        hideOtherOverlay: otherOpen
      };
    },

    // Caller (drawer JS) invokes this AFTER its slide-out animation.
    // - showOtherOverlay=true means the other drawer is still open; the
    //   caller should make sure the other's overlay is visible (since
    //   we hide it when this one is in front).
    afterClose: function (name) {
      state[name] = false;
      var otherOpen = state[other(name)];
      if (otherOpen) bringToFront(other(name));
      return {
        showOtherOverlay: otherOpen
      };
    }
  };
})();
